import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactTelInput from 'react-telephone-input';
import 'react-telephone-input/css/default.css';
import flags from '../../../icons/flags.png';
import styles from './telephone.module.scss';
import '../../component.scss';
import { getTwoLetterCountryCode, getDefaultCountryCode, getDefaultCountry } from '../../../utils/helpers';

class Telephone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      location: null
    };
    const { isRequired, updateFieldErrors, answer } = this.props;

    if (isRequired && (answer === '' || answer === undefined)) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
  }

  async componentDidMount() {
    let countryCode = null;

    try {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });

      const lat = position.coords.latitude;
      const lng = position.coords.longitude;

      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${lat},${lng}&key=${process.env.REACT_APP_GMAPS_KEY}`
      );

      const responseJson = await response.json();

      if (responseJson.status === 'OK') {
        const country = responseJson.results[0].address_components.find(i => i.types.includes('country'));
        countryCode = country?.short_name?.toLowerCase();
      }
    } catch (error) {
      countryCode = null;
    }
    this.setState({ location: countryCode });
  }


  handleAnswerChanged(value, fieldId) {
    const {
      handleValueChange, handleFieldErrorChanged, isRequired, updateFieldErrors, standRequest, defaultCountryCode, onlyDefaultCountryCode
    } = this.props;
    if (onlyDefaultCountryCode) {
      const countryCodeValue = `+${getDefaultCountryCode(defaultCountryCode)}`; // Default country code
      if (!value || !value.startsWith(countryCodeValue)) {
        handleValueChange(countryCodeValue, fieldId);
      } else {
        handleValueChange(value, fieldId);
      }
    } else {
      handleValueChange(value, fieldId);
    }
    let updatedErrors = [];

    if (value === '' || value === undefined) {
      handleFieldErrorChanged(fieldId, isRequired);
      updatedErrors = [
        ...updatedErrors,
        'pulpoforms.errors.not_blank'
      ];
    } else if (isRequired && value.length < 10 && !standRequest) {
      handleFieldErrorChanged(fieldId, true);
      updatedErrors = [
        ...updatedErrors,
        'pulpoforms.errors.invalid_phone_number'
      ];
    } else {
      handleFieldErrorChanged(fieldId, false);
    }
    updateFieldErrors(updatedErrors);
  }

  render() {
    const { answer, fieldId, countryCode, onlyDefaultCountryCode, defaultCountryCode, disabled } = this.props;
    const { location } = this.state;
    return (
    <>
        {location ? (
          <ReactTelInput
            key={location}
            type="text"
            className={`${styles.tel} ${'countryList'}`}
            flagsImagePath={flags}
            onChange={e => this.handleAnswerChanged(e, fieldId)}
            name={fieldId}
            required
            value={answer}
            defaultCountry={location}
            disabled={disabled}
          />
        ) : (
          <>
            {onlyDefaultCountryCode ? (
              <ReactTelInput
                type="text"
                className={`${styles.tel} ${'countryList'}`}
                flagsImagePath={flags}
                onChange={e => this.handleAnswerChanged(e, fieldId)}
                name={fieldId}
                required
                value={answer}
                defaultCountry={getTwoLetterCountryCode(
                  defaultCountryCode || 'USA'
                ).toLowerCase()}
                onlyCountries={[getDefaultCountry(defaultCountryCode || 'USA')]}
                disabled={disabled}
              />
            ) : (
              <ReactTelInput
                type="text"
                className={styles.tel}
                flagsImagePath={flags}
                onChange={e => this.handleAnswerChanged(e, fieldId)}
                name={fieldId}
                required
                value={answer}
                defaultCountry={getTwoLetterCountryCode(
                  countryCode || localStorage.getItem('portalBackendId') || 'us'
                )?.toLowerCase()}
                disabled={disabled}
              />
            )}
          </>
        )}
    </>
    );
  }
}


Telephone.propTypes = {
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  answer: PropTypes.string,
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  updateFieldErrors: PropTypes.func.isRequired
};
const mapStateToProps = state => ({
  countryCode: state?.auth?.profile?.portal_airport?.country_code
});

Telephone.defaultProps = {
  answer: ''
};

export default connect(mapStateToProps)(Telephone);
